import * as yup from 'yup'

export const airportSchema = yup.object().shape({
    code: yup
        .string()
        .required('Airport code is required')
        .matches(/^[A-Z]{3}$/, 'Airport code must be 3 uppercase letters'),
    label: yup
        .string()
        .required('Airport label is required')
        .min(2, 'Airport label must be at least 2 characters'),
    name: yup
        .string()
        .required('Airport name is required')
        .min(2, 'Airport name must be at least 2 characters'),
    address: yup
        .string()
        .required('Address is required'),
    country: yup.mixed()
        .transform((value) => (value && value.value ? value.value : value))
        .required('Country is required'),
    timezone: yup.mixed()
        .transform((value) => (value && value.value ? value.value : value))
        .required('Timezone is required')
}) 